import React, { useEffect } from 'react';
import classes from '../main.module.css';

function PolicyTerms() {

    // Scroll to top on load
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={classes.PolicyContainer}>
            <div className={classes.PolicyHeader}>
                <h1>Policy, Terms & Conditions</h1>
                <p>Last updated: {new Date().toLocaleDateString()}</p>
            </div>

            <div className={classes.PolicyContent}>

                <section>
                    <h2>1. Introduction</h2>
                    <p>
                        Welcome to Feline. These Terms & Conditions and Privacy Policy govern your use of our website
                        and any applications we distribute, including those available on the Google Play Console.
                        Feline is operated by an independent freelance developer and is not a registered corporate entity.
                        By accessing our website or using our applications, you agree to be bound by these terms.
                        If you do not agree, please do not use our services.
                    </p>
                </section>

                <section>
                    <h2>2. Information Collection and Use</h2>
                    <p>
                        For a better experience, while using our Service, we may require you to provide us with certain personally
                        identifiable information. The information that we request will be retained by us and used as described in this privacy policy.
                    </p>
                    <p>
                        Our applications may use third-party services that may collect information used to identify you,
                        such as Google Play Services, Analytics, or Crashlytics. We do not sell or rent your personal data to third parties.
                    </p>
                </section>

                <section>
                    <h2>3. Log Data and Analytics</h2>
                    <p>
                        We want to inform you that whenever you use our apps or website, in a case of an error in the app
                        we may collect data and information (through third-party products) on your phone called Log Data.
                        This Log Data may include information such as your device Internet Protocol ("IP") address, device name,
                        operating system version, the configuration of the app when utilizing our Service, the time and date of your use,
                        and other statistics.
                    </p>
                </section>

                <section>
                    <h2>4. Intellectual Property Rights</h2>
                    <p>
                        Other than the content you own, under these terms, Feline and/or its licensors
                        own all the intellectual property rights and materials contained in our applications and on this website.
                        You are granted a limited license only for purposes of viewing the material contained on this website or using our apps for personal, non-commercial use.
                    </p>
                </section>

                <section>
                    <h2>5. User Responsibilities</h2>
                    <p>
                        By using the applications or website, you agree not to use them for any unlawful purpose
                        or any purpose prohibited under this clause. You agree not to use the services in any way that could damage
                        our services, applications, or the general business of Feline.
                    </p>
                </section>

                <section>
                    <h2>6. Limitation of Liability</h2>
                    <p>
                        In no event shall Feline (the freelance developer), nor any of its affiliates, be held liable
                        for anything arising out of or in any way connected with your use of this website or our applications,
                        whether such liability is under contract. Feline shall not be held liable for any indirect, consequential,
                        or special liability arising out of or in any way related to your use of this website or applications.
                        The apps and site are provided "AS IS".
                    </p>
                </section>

                <section>
                    <h2>7. Links to Other Sites</h2>
                    <p>
                        Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site.
                        Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites.
                        We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                    </p>
                </section>

                <section>
                    <h2>8. Changes to This Policy</h2>
                    <p>
                        We may update our Privacy Policy and Terms & Conditions from time to time. Thus, you are advised
                        to review this page periodically for any changes. We will notify you of any changes by posting the new
                        Policy on this page. These changes are effective immediately after they are posted on this page.
                    </p>
                </section>

                <section>
                    <h2>9. Contact Us</h2>
                    <p>
                        If you have any questions or suggestions about our Policy and Terms & Conditions, do not hesitate to contact us.
                    </p>
                    <ul>
                        <li><strong>Email:</strong> sivarohit60@gmail.com</li>
                        <li><strong>Phone:</strong> +91 88703 43924</li>
                    </ul>
                </section>

            </div>

        </div>
    );
}

export default PolicyTerms;
